import axiosHttp from "../interceptors/error-handling-interceptor";

export const getVasuliList = async (startDate,endDate) => {
  try {
    const response = await axiosHttp.get(`/vyapari/vasuli-list?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error:', error);
  }
};

export const editVasuli = async (vasuli) => {
  try {
    const response = await axiosHttp.put(`/vyapari/edit-vasuli`,vasuli);
    return response.data;
  } catch (error) {
    console.error('Error:', error);
  }
};

export const whatsAppVasuli = async (vasuli) => {
  try {
    const response = await axiosHttp.post(`/vyapari/notify-vasuli`, vasuli);
    return response;
    // console.log("WhatsApp Vasuli Data:", vasuli);
    
    // const fakeResponse = await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve({data:{
    //       responseCode: "200",
    //       responseMessage: "Success",
    //       responseBody:""
    //       // responseBody:
    //       //   '{"messaging_product":"whatsapp","contacts":[{"input":"8349842228","wa_id":"918349842228"}],"messages":[{"id":"wamid.HBgMOTE4MzQ5ODQyMjI4FQIAERgSNkE3NEFFNzUwNkQxQzg1RkFDAA==","message_status":"accepted"}]}',
    //     }});
    //   }, 1000);
    // });
    // return fakeResponse;
    
  } catch (error) {
    console.error("Error posting data:", error);
    return "error";
  }
};
